<template>
    <form @submit.prevent="onSubmitNote" :class="form_class" ref="note_form" id="note_form" novalidate>
        <div class="row">
          <div class="col-12">
            <label for="title" class="float-left">{{ $t("attributes.note.title") }}</label>
            <div class="input-group">
              <input type="text" :value="note.title" class="form-control" name="title" ref="title" @input="onUpdateFormParam">
              <div class="invalid-feedback text-left">{{errorMessagesFor('title')}}</div>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <label for="details" class="float-left">{{ $t("attributes.note.details") }}</label>
            <div class="input-group">
              <textarea :value="note.details" class="form-control" name="details" ref="details" @input="onUpdateFormParam" rows="10"/>
            </div>
          </div>
        </div>

        <div class="row justify-content-left">
          <div class="col-6">
            <button class="btn btn-primary btn-lg btn-block float-start" type="submit" id="submit">{{ $t("submit" )}}</button>
          </div>
        </div>
    </form>
</template>

<script>
import { useStore } from 'vuex';
import { setFieldValidity } from '@/common/form_field_validation';

export default {
  name: 'NoteForm',
  props: [
    "noteId",
    "siteId",
    "ownerType",
    "ownerId"
  ],  
  emits: [
    "closeNotePopup",
    "noteUpdated"
  ],  
  setup(props) {
    const store = useStore();
    let editingNote;

    console.log("Inside views/notes/Form.vue, setup(): props ==> ", props);

    if (props.noteId) {
      editingNote = store.getters.getNoteByUUID(props.noteId);
    } else {
      editingNote = {
        title: null,
        details: null,
        site_uuid: props.siteId,
        owner_type: props.ownerType,
        owner_uuid: props.ownerId
      }
    }
    return {
      note: editingNote
    }
  },
  data() {
    return {
      form_class: 'needs-validation',
      form_errors: {}
    }
  },
  methods: {
    onUpdateFormParam(e) {
      const fieldName = e.target.name;
      this.note[fieldName] = e.target.value;
      setFieldValidity(this.$refs, fieldName, null);
    },
    validateForm() {
      const thisForm = this.$refs.note_form;
      const existingNote = this.$store.getters.getNoteByName(this.$refs.name.value);
      console.log("Inside notes/From.vue validateForm, existingNote ==> ", existingNote);

      // use the browser's checkValidity function to validate the form.
      if (!thisForm.checkValidity()) {
      // then we gather the native error messages
        const inputFields = Array.from(thisForm.getElementsByTagName("input")).concat(Array.from(thisForm.getElementsByTagName("select")));
        const thisHandle = this;
        inputFields.forEach(function(input) {
          const paramName = input.name
          console.log(`Inside views/notes/Form.vue validateForm, input.validationMessage of ${paramName} ===> `, input.validationMessage);
          if (input.validationMessage.length > 0) {
            const paramName = input.name;
            thisHandle.form_errors[paramName] = input.validationMessage;
          }
        });
      }

      // if this.form_errors are empty then the form is valid
      return this.isFormErrorFree(this.form_errors);
    },
    isFormErrorFree(form_errors) {
      return Object.values(form_errors).reduce(function(acc, val1) { 
        return ((val1 === null) || (val1.length === 0)) && acc 
      }, true);
    },    
    errorMessagesFor(fieldName) {
      if (this.$refs[fieldName]) {
        return this.$refs[fieldName].validationMessage
      }
    },
    onSubmitNote() {
      console.log("Inside notes/Form.vue, onSubmitNote(), this.note ==> ", this.note);
      if ((this.note.title) || (this.note.details)) {
        if (!this.note.title) {
          this.note.title = this.note.details.split(' ').slice(0, 12).join(" ") + " ...";
        }
        let noteUUID;
        if (this.noteId) {
          this.$store.dispatch("modifyNote", this.note);
          noteUUID = this.noteId;
        } else {
          noteUUID = this.$store.dispatch("addNote", this.note);
        }
        this.$emit("noteUpdated", noteUUID);
      } else {
        this.$emit("closeNotePopup");
      }
    }
  }
}
</script>
